
// Automatically generated by extract-default-properties.mjs

import {
  type LayoutProperties,
  type CostWeights
} from "./layout.js";

export const DEFAULT_PROPERTIES = {
  crossingWeight: 10,
  pathLengthWeight: 2,
  orderMismatchWeight: 2,
  bundleMismatchWeight: 3,
  divergenceWeight: 4,
  bellTipShape: 0.1,
  bellTipSpread: 0.5,
  bellStrokeWidth: 1,
  bellStrokeDarkening: 0.6,
  bellPlateauPos: 0.7,
  sampleHeight: 110,
  sampleWidth: 90,
  inferredSampleHeight: 120,
  gapHeight: 60,
  sampleSpacing: 60,
  columnSpacing: 90,
  tentacleWidth: 2,
  tentacleSpacing: 5,
  inOutCPDistance: 0.3,
  bundleCPDistance: 0.6,
  sampleFontSize: 12,
  showLegend: true,
  phylogenyColorScheme: true,
  phylogenyHueOffset: 0,
  phylogenyLightnessStart: 0.94,
  phylogenyLightnessEnd: 0.68,
  phylogenyChromaStart: 0.025,
  phylogenyChromaEnd: 0.21,
  sampleTakenGuide: "text",
  showRankTitles: true,
  normalsAtPhylogenyRoot: false
} as LayoutProperties;
